export var HttpStatus;
(function (HttpStatus) {
    HttpStatus[HttpStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpStatus[HttpStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpStatus[HttpStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
})(HttpStatus || (HttpStatus = {}));
//# sourceMappingURL=http-status.enum.js.map